// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../config/fbConfig';
// import React, { useEffect, useState } from 'react';
// import Logo from '../images/school_logo.png';

// const ArchiveTerms = () => {
//   const { sectionId, sessionId } = useParams();
//   const [terms, setTerms] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchTerms = async () => {
//       try {
//         const snap = await getDocs(collection(db, 'terms'));
//         const sortedTerms = snap.docs
//           .map(doc => ({ id: doc.id, ...doc.data() }))
//           .sort((a, b) => a.name.localeCompare(b.name));
//         setTerms(sortedTerms);
//       } catch (error) {
//         console.error('Error fetching terms:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTerms();
//   }, []);

//   return (
//     <>
//       <div className="top-elements row align-center space-between">
//         <button onClick={() => navigate(-1)} className="back-link back-link1">
//           <i className="fa-solid fa-arrow-left size3"></i>
//         </button>
//         <div className="column align-center justify-center">
//           <img src={Logo} className="middle-logo" alt="logo" />
//         </div>
//         <Link to="#" className="home-link" onClick={() => window.location.reload()}>
//           <i className="fa-solid fa-rotate-right size4"></i>
//         </Link>
//       </div>

//       <div className="login-page-items column align-center">
//         <div className='breadcrumb'>
//           <button onClick={() => navigate(-2)} className="back-link back-link1 back-link2">
//             Section &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
//           </button>
//           <button onClick={() => navigate(-1)} className="back-link back-link1 back-link2">
//             Session &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
//           </button>
//           <button className="back-link back-link1 back-link2">
//             Term
//           </button>
//         </div>
//         <h2 className="manage-page-heading manage-page-heading-select caps size4">Select Term</h2>
//         <div className="scroll-fixed scroll-fixed1">
//           <div className="class-list class-list-d scrollable class-items">
//             {loading ? (
//               <p className="loading-text male-female-stat">Loading terms...</p>
//             ) : terms.length === 0 ? (
//               <p className="empty-text male-female-stat">No terms available.</p>
//             ) : (
//               terms.map(term => (
//                 <div key={term.id}>
//                   <button
//                     className="class-item class-item1 class-item1-d"
//                     onClick={() =>
//                       navigate(`/archives/${sectionId}/${sessionId}/${term.id}`)
//                     }
//                   >
//                     {term.name}
//                   </button>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ArchiveTerms;





import { useParams, useNavigate, Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Logo from '../images/school_logo.png';

Modal.setAppElement('#root');

const ArchiveTerms = () => {
  const { sectionId, sessionId } = useParams();
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Multi-select modal state
  const [isMultiSelectModalOpen, setIsMultiSelectModalOpen] = useState(false);
  const [selectedTermIds, setSelectedTermIds] = useState([]);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const snap = await getDocs(collection(db, 'terms'));
        const sortedTerms = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setTerms(sortedTerms);
      } catch (error) {
        console.error('Error fetching terms:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  const handleTermCheckboxChange = (termId) => {
    setSelectedTermIds(prev =>
      prev.includes(termId)
        ? prev.filter(id => id !== termId)
        : [...prev, termId]
    );
  };

  const handleProceedToClassSelection = () => {
    if (selectedTermIds.length === 0) {
      alert('Please select at least one term.');
      return;
    }

    // Navigate to the class selection page and pass the selected term IDs
    // Adjust the path if your class-selection route is different
    navigate(`/archives/${sectionId}/${sessionId}/classes`, {
      state: { selectedTermIds }
    });

    // Reset
    setIsMultiSelectModalOpen(false);
    setSelectedTermIds([]);
  };

  return (
    <>
      <div className="top-elements row align-center space-between">
        <button onClick={() => navigate(-1)} className="back-link back-link1">
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>

      <div className="login-page-items column align-center">
        <div className='breadcrumb'>
          <button onClick={() => navigate(-2)} className="back-link back-link1 back-link2">
            Section &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button onClick={() => navigate(-1)} className="back-link back-link1 back-link2">
            Session &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button className="back-link back-link1 back-link2">
            Term
          </button>
        </div>

        <h2 className="manage-page-heading manage-page-heading-select caps size4">
          Select Term
        </h2>

        <div className="scroll-fixed scroll-fixed1">
          <div className="class-list class-list-d scrollable class-items">
            {loading ? (
              <p className="loading-text male-female-stat">Loading terms...</p>
            ) : terms.length === 0 ? (
              <p className="empty-text male-female-stat">No terms available.</p>
            ) : (
              terms.map(term => (
                <div key={term.id}>
                  <button
                    className="class-item class-item1 class-item1-d"
                    onClick={() =>
                      navigate(`/archives/${sectionId}/${sessionId}/${term.id}`)
                    }
                  >
                    {term.name}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Button at the bottom */}
        {!loading && terms.length > 0 && (
          <div style={{ marginTop: '20px', marginBottom: '30px', width: '100%', maxWidth: '400px' }}>
            <button
              className="login-button login-button-d caps"
              style={{ width: '100%' }}
              onClick={() => {
                setSelectedTermIds([]);
                setIsMultiSelectModalOpen(true);
              }}
            >
              Cumulative Results
            </button>
          </div>
        )}
      </div>

      {/* Multi-select Terms Modal */}
      <Modal
        isOpen={isMultiSelectModalOpen}
        onRequestClose={() => {
          setIsMultiSelectModalOpen(false);
          setSelectedTermIds([]);
        }}
        contentLabel="Select Multiple Terms"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Select Terms to Combine</h2>
        <p className="male-female-stat" style={{ marginBottom: '15px' }}>
          Choose one or more terms. After selecting, you will be taken to the class selection page.
        </p>

        <div style={{ maxHeight: '320px', overflowY: 'auto', marginBottom: '20px' }}>
          {terms.map(term => (
            <label
              key={term.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '10px',
                cursor: 'pointer',
                padding: '8px 10px',
                borderRadius: '6px',
                backgroundColor: selectedTermIds.includes(term.id) ? '#e8f4fd' : 'transparent'
              }}
            >
              <input
                type="checkbox"
                className='gold-tick'
                checked={selectedTermIds.includes(term.id)}
                onChange={() => handleTermCheckboxChange(term.id)}
              />
              <span>{term.name}</span>
            </label>
          ))}
        </div>

        <div className="row align-center gap-1">
          <button
            className="login-button"
            type="button"
            onClick={() => {
              setIsMultiSelectModalOpen(false);
              setSelectedTermIds([]);
            }}
          >
            Cancel
          </button>
          <button
            className="login-button"
            type="button"
            onClick={handleProceedToClassSelection}
          >
            Go To Classes
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ArchiveTerms;